export const SUPPLIER_TYPE = [
    {
        value: "contractor",
        label: "Contractor",
    },
    {
        value: "broker",
        label: "Broker",
    },
    {
        value: "supplier_agent",
        label: "Supplier Agent",
    },
];

export const SUPPLIER_PARTNER_TYPE = {
    value: "supplier_partner",
    label: "Supplier Partner",
}
export const TRUCK_TYPE = [
    {
        value: "trella",
        label: "Trella",
    },
    {
        value: "dababa",
        label: "Dababa",
    },
    {
        value: "jumbo",
        label: "Jumbo",
    },
    {
        value: "van",
        label: "Van",
    },
];
export const PAYMENT_METHOD = [
    {
        value: "bank_account",
        label: "Bank Account",
    },
    {
        value: "e_wallet",
        label: "E Wallet",
    },
    {
        value: "mezza_card",
        label: "Mezza Card",
    },
];
export const EWALLET_NAME = [
    {
        value: "vodafone",
        label: "Vodafone",
    },
    {
        value: "orange",
        label: "Orange",
    },
    {
        value: "we",
        label: "We",
    },
    {
        value: "etisalat",
        label: "Etisalat",
    },
];

export const HAS_ACOMPANY = [
    {
        value: true,
        label: "Yes",
    },
    {
        value: false,
        label: "No",
    },
];
